import {Box, Flex, Heading, Text} from '@chakra-ui/react';
import {BreadcrumbLine, ProviderLogo} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {colors} from 'theme';
import {TranslationKeys} from 'translations';
import {ProviderTypeEnum} from 'types';
import LinkUI from 'ui/LinkUI';
import {getDeliveryTimeString} from 'utils/helpers';

interface Props {
  provider: {
    slug: string;
    name?: string;
    ratings?: string;
    avg_delivery_time?: number;
    delivery_price?: number;
    providerType?: ProviderTypeEnum;
    logo_thumbnail?: string;
    label?: string;
    online_payment?: boolean;
    loyalty_info?: string;
    discount?: number;
  };
  hasPreorder?: boolean;
  t: (term: TranslationKeys) => string;
}

export const OrderProviderSummary: FC<Props> = ({provider, hasPreorder}) => {
  const {t} = useTranslation();
  const providerRating = parseFloat(provider?.ratings ?? '0');
  const rating = providerRating > 0 ? providerRating.toFixed(2) : '';

  const deliveryTime = getDeliveryTimeString(provider?.avg_delivery_time);

  const isMetro = provider.name === 'Metro';
  const pathname = isMetro ? `/${provider.slug}` : `/restaurant/${provider.slug}`;
  const linkHref = isMetro ? {pathname} : {pathname, query: {slug: provider.slug}};

  return (
    <Flex justifyContent="space-between">
      <Flex>
        <ProviderLogo size="65px" img={provider.logo_thumbnail} slug={provider.slug} isMetro={isMetro} />
        <Flex direction="column" ml="15px">
          <LinkUI href={linkHref}>
            <Heading as="a" fontSize={['18px', '26px']} fontWeight="700" cursor="pointer">
              {provider.name}
            </Heading>
          </LinkUI>
          <BreadcrumbLine
            ratingsCount={rating}
            deliveryTime={deliveryTime}
            hasPreorder={hasPreorder}
            separateFewRatings
          />
          <Flex alignItems="center" mt="4px" justifyContent="space-between" gap={2}>
            {!provider.online_payment && (
              <Box color="rgb(5, 150, 250)" bg="rgba(5, 150, 250, 0.1)" p="2px" px="10px" borderRadius="md">
                <Text ml={provider.discount ? '5px' : '0px'} fontSize={['9px', '10px']} fontWeight="semibold">
                  {t('onlyCashPayment')}
                </Text>
              </Box>
            )}
            {!!provider.discount && (
              <Box bg="rgba(250, 5, 111, 0.1)" p="2px" px="10px" borderRadius="md">
                <Text
                  ml={provider.discount ? '5px' : '0px'}
                  fontSize={['9px', '10px']}
                  color={colors.pink}
                  fontWeight="semibold"
                >
                  {provider.discount}% {t('DISCOUNT')}
                </Text>
              </Box>
            )}
            {provider.loyalty_info && (
              <Box bg="rgba(250, 5, 111, 0.1)" p="2px" borderRadius="md" px="10px">
                <Text
                  ml={provider.discount ? '5px' : '0px'}
                  fontSize={['9px', '10px']}
                  color={colors.pink}
                  fontWeight="semibold"
                >
                  {provider.loyalty_info}
                </Text>
              </Box>
            )}
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
